// AI block schemas removed in ofuro-wiki
import { AffineSchemas } from '@blocksuite/affine/schemas';
import { Schema } from '@blocksuite/affine/store';

let _schema: Schema | null = null;
export function getAFFiNEWorkspaceSchema() {
  if (!_schema) {
    _schema = new Schema();
    _schema.register(AffineSchemas);
  }

  return _schema;
}
